// i18n.js — JSON-backed string lookup. Twenty lines of logic.
//
// Languages are JSON files in src/i18n/{lang}.json. Keys are dotted paths.
// Missing keys fall back to English, then to the key itself.
//
// Note: this is the *UI string* translation layer. Item/list/lyric content is
// localised through the LanguageManager (En/Zh toggle on the data layer).

/** @type {Record<string, Record<string, string>>} */
const cache = {};
let current = "en";
/** @type {Record<string, string>} */
let strings = {};
/** @type {Record<string, string>} */
let fallback = {};

/** @param {string} lang */
export async function setLanguage(lang) {
  if (!cache[lang]) {
    const res = await fetch(`./src/i18n/${lang}.json`);
    cache[lang] = await res.json();
  }
  if (!cache.en) {
    const res = await fetch(`./src/i18n/en.json`);
    cache.en = await res.json();
  }
  current = lang;
  strings = cache[lang] ?? {};
  fallback = cache.en ?? {};
  document.documentElement.lang = lang;
}

/**
 * @param {string} key e.g. "list.title"
 * @param {Record<string, string|number>} [vars]
 * @returns {string}
 */
export function t(key, vars) {
  const raw = strings[key] ?? fallback[key] ?? key;
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? `{${k}}`));
}

export function getLanguage() { return current; }
